import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Tabs from "../../Components/Tabs";
import EnvironmentStatusTable from "./internal/EnvironmentStatusTable";
import { init } from "../Deployments/actions";
import { push, getParsedQuery } from "yarrr";

// css
import css from "./internal/EnvironmentStatus.styl";

// constants
import { PRODUCTION_ENVIRONMENTS, TESTING_ENVIRONMENTS } from "./internal/constants";

const TABS = ["Production", "Testing"];

export const EnvironmentStatus = (props) => {
	const dispatch = useDispatch();
	const currentTab = props.query.tab || TABS[0];

	const setCurrentTab = (tab) => {
		dispatch(push(`?tab=${tab}`));
	};

	useEffect(() => {
		props.init();
	}, []);

	return (
		<div className={css.content}>
			<div>
				<Tabs tabs={TABS} currentTab={currentTab} onChange={setCurrentTab} />
			</div>
			<div className={currentTab === TABS[0] ? "" : css.hidden}>
				{PRODUCTION_ENVIRONMENTS.map((environment) => (
					<EnvironmentStatusTable key={environment.name} environment={environment} />
				))}
			</div>
			<div className={currentTab === TABS[1] ? "" : css.hidden}>
				{TESTING_ENVIRONMENTS.map((environment) => (
					<EnvironmentStatusTable key={environment.name} environment={environment} />
				))}
			</div>
		</div>
	);
};

EnvironmentStatus.propTypes = {
	init: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
	query: getParsedQuery(state),
});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(init()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnvironmentStatus);
